import { render, staticRenderFns } from "./Testing.vue?vue&type=template&id=e25c60ac&scoped=true&"
import script from "./Testing.vue?vue&type=script&lang=js&"
export * from "./Testing.vue?vue&type=script&lang=js&"
import style0 from "./Testing.vue?vue&type=style&index=0&id=e25c60ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25c60ac",
  null
  
)

export default component.exports